// extracted by mini-css-extract-plugin
export default {"navbar__Container":"Navbar_navbar__Container__uJkFM","navbar_link":"Navbar_navbar_link__mUCwi"};